import { RugbyLeagueIncidentId } from '@collector/sportsapi-client-legacy'

import { AssignIncidentOnPitchConfig } from '../../../configuration'

const sharedButtonClass =
  'min-h-6! h-6! @sm:min-h-7! @2md:min-h-8! @sm:h-7! @2md:h-8! text-3xs! @sm:text-2xs!'

const scoreButtonClass = `${sharedButtonClass} w-[50%]! @md:w-20! @md:min-w-20!`

export const assignIncidentOnPitchConfig: AssignIncidentOnPitchConfig<RugbyLeagueIncidentId> =
  {
    assignIncidentOnPitchIncidents: new Map([
      [
        RugbyLeagueIncidentId.ConversionAttempt,
        [
          {
            incidentId: RugbyLeagueIncidentId.ConversionGoal,
            variant: 'score',
            name: 'Goal',
            class: scoreButtonClass,
          },
          {
            incidentId: RugbyLeagueIncidentId.ConversionMissed,
            variant: 'missed',
            name: 'Missed',
            class: scoreButtonClass,
          },
        ],
      ],
      [
        RugbyLeagueIncidentId.PenaltyAwarded,
        [
          {
            incidentId: RugbyLeagueIncidentId.PenaltyKickGoal,
            variant: 'score',
            name: 'Goal',
            class: scoreButtonClass,
          },
          {
            incidentId: RugbyLeagueIncidentId.PenaltyKickMissed,
            variant: 'missed',
            name: 'Missed',
            class: scoreButtonClass,
          },
          {
            incidentId: RugbyLeagueIncidentId.Kick,
            variant: 'default',
            name: 'Kick',
            class: scoreButtonClass,
          },
        ],
      ],
      [
        RugbyLeagueIncidentId.Cards,
        [
          {
            incidentId: RugbyLeagueIncidentId.YellowCard,
            name: 'Yellow',
            class: `${sharedButtonClass} min-w-10! w-10! bg-warning-5! border-warning-5! hover:bg-warning-7! hover:border-warning-7!`,
          },
          {
            incidentId: RugbyLeagueIncidentId.RedCard,
            name: 'Red',
            class: `${sharedButtonClass} min-w-10! w-10! bg-error-5! border-error-5! hover:bg-error-7! hover:border-error-7!`,
          },
          {
            incidentId: RugbyLeagueIncidentId.GreenCard,
            name: 'Green',
            variant: 'score',
            class: `${sharedButtonClass} min-w-11! w-11!`,
          },
        ],
      ],
    ]),
  }
